import { FormHelperText, DialogContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const DialogContentStyle = styled(DialogContent)`
  padding-bottom: 24px;
`;

export const useCssClasses = makeStyles((theme: any) => ({
  button: {
    width: '121px',
  },
}));
